import { useState, useEffect } from 'react'

import Text from '@/elements/Text'
import Flex from '@/elements/Flex'
import Loading from '@/elements/Loading'
import Modal from '@/components/Modal'

import { AdditionalImageEx1, AdditionalImageEx2 } from '@/assets'

const additionalImagesInfo = [
  {
    title: '3 Clear, frontal photos per person, see screenshot below',
    details: [
      'Varied lighting, angles, clothes, hair-styles, etc.'
    ]
  },
  {
    title: 'As high quality as possible:',
    details: [
      'No filters',
      'No compressed files'
    ]
  },
  {
    title: 'Consistent framing',
    details: [
      'Headshots',
      'Head and shoulders'
    ]
  },
  {
    title: 'Size:',
    details: [
      'At least 400x400px face area'
    ]
  },
  {
    title: 'Format:',
    details: [
      'JPEG or PNG, no transparency'
    ]
  },
  {
    title: 'Example:',
  }
]

function AdditionalImagesInfo({
  show,
  setShow
}: {
  show: boolean,
  setShow: (show: boolean) => void
}) {
  const [loadingImages, setLoadingImages] = useState(false)

  useEffect(() => {
    if (show) {
      setLoadingImages(true)
      const timer = setTimeout(() => {
        setLoadingImages(false)
      }, 1000)

      return () => clearTimeout(timer)
    }
    return undefined
  }, [show])

  const imageExample = (imgSrc: string, altText: string) => (
    <Flex
      radius='small'
      style={{
        aspectRatio: '1/1',
        overflow: 'hidden',
      }}
    >
      <img
        src={imgSrc}
        alt={altText}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          objectPosition: 'top',
        }}
      />
    </Flex>
  )

  return (
    <Modal
      title='Show your best side!'
      isOpen={show}
      onCancel={() => setShow(false)}
      style={{
        width: 642,
      }}
    >
      {loadingImages ? (
        <Flex align='center' justify='center' wfull py={8}>
          <Loading />
        </Flex>
      ) : (
        <>
          <Text variant='h4' color='black'>For effective facial recognition, we'll need:</Text>
          <Flex gap={3} mt={4} pb={3}>
            {additionalImagesInfo.map((info, idx) => (
              <ul key={idx}>
                <li><Text color='black'>{info.title}</Text></li>
                <ul>
                  {info?.details?.map((detail, detailIdx) => (
                    <li key={detailIdx}>
                      <Text color='black-light-40'>{detail}</Text>
                    </li>
                  ))}
                </ul>
              </ul>
            ))}
            <Flex inline grid gap={3}>
              {imageExample(AdditionalImageEx1, 'Example of additional image 1')}
              {imageExample(AdditionalImageEx2, 'Example of additional image 2')}
            </Flex>
          </Flex>
        </>
      )}
    </Modal>
  )
}

export default AdditionalImagesInfo
